import { MainContext } from "../Context";
import React, { Fragment, useContext } from "react";

const AboutUs = () => {
  const { setting } = useContext(MainContext);

  // ==================================================================

  const teamMembers = [
    {
      id: 1,
      name: "این هیوک سو",
      job: "کوک سانیم",
    },
    {
      id: 2,
      name: "فرشید شب افروزان",
      job: "جو ایم کوانگ جانیم",
    },
    {
      id: 3,
      name: "داود روستایی",
      job: "رئیس سبک کوک سول وان در ایران",
    },
    {
      id: 5,
      name: "عیسی فرهمند",
      job: "نائب رئیس",
    },
    {
      id: 6,
      name: "فاطمه سلطان آبادی",
      job: "نائب رئیس بانوان",
    },
    {
      id: 7,
      name: "حمزه احمدی",
      job: "دبیر سبک",
    },
  ];

  // ==================================================================

  return (
    <Fragment>
      <section className="pt-4">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div
                className="card bg-dark-overlay-4 overflow-hidden card-bg-scale h-400 text-center"
                style={{
                  backgroundImage: `url('${setting.about_banner}')`,
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                }}
              >
                <div className="card-img-overlay d-flex align-items-center p-3 p-sm-4">
                  <div className="w-100 my-auto">
                    <h1 className="text-white display-5">درباره ما</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pt-md-3 py-0">
        <div className="container">
          <div className="row">
            <div className="col-xl-9 mx-auto">
              <h3 className="fw-bold">كوك سول وان چيست ؟</h3>
              <p className="lead text-justify">
                كـوك ســول وان تـنها يك ورزش يا يـك روش دفاع شخصي صرف همچون ساير
                سبكهاي شرقي نيست . كــوك سول يــك سيستم جـامع هــنرهاي رزمي است
                كه از انواع فنــون و روش هاي رزمي سنــتي كــه طـي قــرن ها در
                كشــور كره شكل گرفتــه انـد ، نشــات گرفته است در كوك ســول ضمـن
                تلاش در جهت حفـظ و زنـده نگهداشتن هنرهاي رزمي سنتي كره ، به
                تقويت و سالم سازي فكر و جسم افراد نيز پرداخته مي شود . گرچه
                سابقه فنون و روش هاي دفـاعي كــوك سول به دوران باستـان باز مي
                گردد ، اما به عنوان يك سيستم بــرنامه ريزي شده و مدون ، كــوك
                سول در قــرن حاضر تنـظيم شده است.
              </p>
              <p className="text-justify">
                استــاد ايـن هيوك سو پس از چهل سال ممـارست و مطالعه و تحقــيق
                موفق شد بيش از 3600 تكنيك را جمع آوري و منـظم كرده و در سال 1961
                سازمان هنرهاي رزمي سنتي كره را بنيان گذاري كند . هم اكنون در
                سراسر اروپا ، آسيا و قاره امريكا بيش از شش هزار مدرسه كوك سول
                وجود دارد و توانايي و تعداد آنها روز به روز بيشتــر مي شود . از
                نقطــه نظـــر دفاع شخصي ، كوك سول بي نظيــر است . هيچ سيســتمي
                را نمي توان يــافت كه اينچنــين تــوانسته باشــد ضــربات دست و
                پـا ، افـت ، پرتاب ، استفاده از مفاصل و نقاط نقاط حساس و نيز
                سلاح هاي سرد را با هم تلفيق كرده و حركاتي نرم و روان و زيبا و در
                عيــن حال موثر و پرقدرت به وجود آورد . در كوك سول از امكاناتي
                اساسي از جمله تمركز ، تنــفس صحيــح ، طب ســوزني و نقاط حساس بدن
                استفاده مي شود تا انرژي داخلي شاگردان پرورش يابد و از اين طريق
                از مشكلات مــربوط به كهولت جلوگيري گردد. در بعد اخلاق و انديشه
                در كوك سول ، تواضــع ، ادب ، كنـترل نفس ، وفاداري و احتــرام به
                ديـگران بسيـار مورد تاكيــد مي باشنــد . در مجموع ، ابعاد مختلف
                كوك سول هنرآموز را به يــك زندگي طولاني تــوام با سلامت كامل سوق
                مي دهــد.
              </p>

              <h3 className="fw-bold">تاريخچه هنر رزمي سنتي كره</h3>
              <p className="text-justify">
                در دنياي هنرهاي رزمي هــر روزه با نام هاي جديدي روبرو مي شويم و
                از تنوع آنها گــاهي دچار حيــرت و سردر گمي مي شويم . اما نكتــه
                مهم آن است كه اغلب ايـــن هنرها ، سبك هايي از يك سيسـتم كلي با
                فلسفه و تاريخچه اي مشخص هستنــد . و تشــخيص اين سيستم ها ما را
                قادر خواهد ساخت به يك شـــناخت كلي از هنـرهاي رزمي دست يابيم .
                در اين مقاله مطالبـي مختصر و فشـرده در خصوص كوك سول وان ، هنر
                رزمي سنتي كره ، ( كه در جهان به عنوان يك سيستم از هنرهاي رزمي
                شناخته شده و نه يك سبك ) بيان مي شود: كوك سول وان kuk sool won
                به معناي سازمان هنرهاي رزمي سنتي كــره باستان مي باشد.كـــه
                بـــه تفكــيك چنيـــن مي شود: كـوك (kuk ) : به معنــاي ملت يا
                كشـــور. سـول (sool) : يعني فنــون هنـــر رزمي با در نظر گـرفتن
                جنبه هاي فكري ، روحي ، فرهنگي ، فلسفي ، و ارثــي كــره . وان (
                won): بـه معنــاي انجمن يا ســازمان . تكنيــك هاي كوك سـول عمدتا
                از سه شاخه هنرهاي رزمي سنتي كره باستان سرچشمه مي گيرد، كه
                عبارتند از: 1_ سـادو مو سول (Sado Mu Sool): خانوادگي هنــرهاي
                رزمي قبــيله اي يا . 2- بولكيـو مو سول ( Bulkyo Mu Sool): بودايي
                هنــرهاي رزمي راهب هاي . 3- كونگ جونگ مو سول ( Koong Joong Mu
                Sool) امپراطوري: هنـرهاي رزمي . هنــرهاي رزمي قبــيله اي چندين
                قرن قبل از ميلاد مسيح وجود داشته و شامل روشهايي است كه قبايل
                براي دفاع در مقابل دشمنان و حيوانات وحشي به كار مي بــردند در
                ابتدا سلاح اصلي سنگ بــود ، سپس فنــون پـــرتاب اين اسلحه ها و
                پاشيــدن شــن بــراي كور كردن دشمن وغلبه بر وي مورد استفاده قرار
                گرفت و بـه استفاده از شمشيــر هـم رواج پيـدا كرد . واحدهاي رزمي
                دهقاني تشكيل گرديد كه هدف آن دفاع از دنبــال آن قبايــل هم
                پيمــان و حــراست از كشور بــود . امپراطوري هاي كره بارها سعي
                كردنـد كه قدرت اين قبــايل را تضعيف نمايند ؛ ليكن اين واحدها به
                صورت ارتش هاي كوچك زيرزميني باقي ماندنــد . بسياري از تكنيكهاي
                مربوط به شمشير ، چاقو ، پرتاب شن و نظاير آن از اين واحدها به كوك
                سول وان به ارث رسيده است. راهب هاي بودايي هنر رزمي خاص خود را
                سالها قبل از ميلاد مسيح ايجاد كرده بودند . آنها از اين هنـــر به
                سه دليل بهره مي گرفتند : اول به دليــــل سلامتي ، چون آنها در
                طــول روز ساعت ها در حال نشسته عبادت مي كردنــد و اشتغال به
                تمـــرين هنرهاي رزمي سبـب مي شــد كه قلب و ريـــه ،‌گــردش خون و
                ماهيچه ها ، جهــاز هاضمه و سايـــر ارگان هاي جسمي آنها سلامت خود
                را حفــظ كنند . دليل دوم دفاع شخصي بود چون آنها مجبور بودند كه
                به دلايل گوناگون مسافت هاي طولاني را بپــيمايند لـــذا احتمال
                داشت كه مــورد تهــاجم دزدها و حيوانات قرار گيـــرند كه با بهره
                گيري از وسايلي چون عصـــا ، چوب و بادبـــزن از خود محــافظت مي
                كردند . دليــــل سوم عبارت بــــود از دفاع در بــــرابر هجوم
                متجاوزين خـــارجي هنرهاي رزمي وسيله ارزشمندي بود براي محافظت از
                مجموعه هاي مذهبــي بوداييان و تماميت ارضي كشـور. هــــنرهاي رزمي
                امپراطوري در زمان سـه امپــــراطوري كره شكل گـرفت اين حكومت ها
                در سده نخست قبل از ميلاد و در قسمت هايي از كره فرمانروايي مي
                كردند . جنگجويان وابسته به درباردر حين ســواركاري ،‌پـــرتاب
                چاقو ،‌دفاع با دست وپاي غير مسلح ،‌دفاع با پرتاب حريف ، شنا و
                مبارزه در آب ،شكار حيــــوانات و صيد ماهي ، موسيقي ،‌سياست و
                دانش هاي سنتي كــره را بايد مي آموختـنـد. اين دلاوران اعتقاد
                داشتند كه در طول حيات انسان جسم و روح جــدايي ناپذيرند و سلامت
                يكي مستلـزم پاكي و سلامتي ديگري است . بنابراين مي كوشيدنـــد كه
                هم از نظر جسمي و هم از از جهت روحي خود را تقويت كنند و براي نيل
                به اين هدف بيشتر تمرينات و مطالعات خود را در ميان طبيعت زيباي
                كوه ها و رودخانه ها انجام مي دادند. آنها همچنين باورداشتند كه
                اطاعت از پـدر و مادر ، گذشت و فــداكاري در مقابل دوستــان ، عقب
                نشستـن در ميدان جنگ ، كشتن از روي منطق و دفاع از ميهن از وظايف
                اصلي يك هنرجوي رزمي به شمار مي آينــــــد.
              </p>

              <div className="row justify-content-center mb-4 mt-3 g-4">
                {teamMembers.map((item) => (
                  <div key={item.id} className="col-6 col-lg-3">
                    <div className="text-center mx-auto">
                      <div className="avatar avatar-xxl mb-2 mx-auto">
                        <img
                          className="avatar-img rounded-circle"
                          src={`/imgs/aboutUs/team-${item.id}.jpg`}
                          alt={item.name}
                        />
                      </div>
                      <h5>{item.name}</h5>
                      <p className="m-0">{item.job}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default AboutUs;
